var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status-box"},[_c('h6',[_vm._v(_vm._s(_vm.$t('status')))]),_vm._l((_vm.notes),function(note){return _c('div',{key:note.id,staticClass:"status-text"},[_vm._v(" "+_vm._s(note.body)+" "),_c('q-separator')],1)})],2)}
var staticRenderFns = []

export { render, staticRenderFns }